/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _path41, _path42, _path43, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path44, _path45, _path46, _path47, _path48, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _path49, _path50, _path51, _path52, _circle26, _path53, _path54, _path55, _circle27, _path56, _circle28, _path57, _circle29, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _circle30, _circle31, _circle32, _path79, _circle33, _path80, _circle34, _circle35, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _circle36, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _circle37, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _circle38, _path178, _path179, _path180, _circle39, _path181, _path182, _circle40, _circle41, _circle42, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277;
const Move = /*#__PURE__*/React.forwardRef(function Move({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Move.propTypes = iconPropTypes;
}
const Movement = /*#__PURE__*/React.forwardRef(function Movement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Movement.propTypes = iconPropTypes;
}
const Mp3 = /*#__PURE__*/React.forwardRef(function Mp3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H22v2h6v4H24v2h4v4H22v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mp3.propTypes = iconPropTypes;
}
const Mp4 = /*#__PURE__*/React.forwardRef(function Mp4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mp4.propTypes = iconPropTypes;
}
const Mpeg = /*#__PURE__*/React.forwardRef(function Mpeg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32,21H28a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H28v6h2V17H29l0-2h3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mpeg.propTypes = iconPropTypes;
}
const Mpg2 = /*#__PURE__*/React.forwardRef(function Mpg2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32,21H26V17a2.002,2.002,0,0,1,2-2h2V13H26V11h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H28v2h4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21H20a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H20v6h2V17H21l0-2h3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mpg2.propTypes = iconPropTypes;
}
const MultiuserDevice = /*#__PURE__*/React.forwardRef(function MultiuserDevice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25h-6c-1.66,0-3,1.34-3,3v2h2v-2c0-.55.45-1,1-1h6c.55,0,1,.45,1,1v2h2v-2c0-1.66-1.34-3-3-3ZM13,20c0,2.21,1.79,4,4,4s4-1.79,4-4-1.79-4-4-4-4,1.79-4,4ZM19,20c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM22,18c1.1,0,2,.9,2,2s-.9,2-2,2v2c2.21,0,4-1.79,4-4s-1.79-4-4-4v2ZM25,25h-1v2h1c.55,0,1,.45,1,1v2h2v-2c0-1.66-1.34-3-3-3ZM6,4h16v10h2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h3v-2h-3V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MultiuserDevice.propTypes = iconPropTypes;
}
const Music = /*#__PURE__*/React.forwardRef(function Music({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Music.propTypes = iconPropTypes;
}
const MusicAdd = /*#__PURE__*/React.forwardRef(function MusicAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MusicAdd.propTypes = iconPropTypes;
}
const MusicRemove = /*#__PURE__*/React.forwardRef(function MusicRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MusicRemove.propTypes = iconPropTypes;
}
const Mysql = /*#__PURE__*/React.forwardRef(function Mysql({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m28.2471,11.9248h3.1748l-4.6465,13.938c-.3066.9351-.7402,1.6255-1.2998,2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705,5.6353.874,3.4961h.1377l.8975-3.4961,1.7705-5.6353Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2178 13.4658L14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mysql.propTypes = iconPropTypes;
}
const NameSpace = /*#__PURE__*/React.forwardRef(function NameSpace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4H7V6H4v4H7Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H15V12H9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H23V12H17z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H25V10h3V6H25V4h3a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,12Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4H23V6H17z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H15V6H9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0023,2.0023,0,0,1-2-2V22a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,28ZM4,22v4H28V22Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NameSpace.propTypes = iconPropTypes;
}
const NavaidCivil = /*#__PURE__*/React.forwardRef(function NavaidCivil({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidCivil.propTypes = iconPropTypes;
}
const NavaidDme = /*#__PURE__*/React.forwardRef(function NavaidDme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidDme.propTypes = iconPropTypes;
}
const NavaidHelipad = /*#__PURE__*/React.forwardRef(function NavaidHelipad({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidHelipad.propTypes = iconPropTypes;
}
const NavaidMilitary = /*#__PURE__*/React.forwardRef(function NavaidMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidMilitary.propTypes = iconPropTypes;
}
const NavaidMilitaryCivil = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidMilitaryCivil.propTypes = iconPropTypes;
}
const NavaidNdb = /*#__PURE__*/React.forwardRef(function NavaidNdb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidNdb.propTypes = iconPropTypes;
}
const NavaidNdbDme = /*#__PURE__*/React.forwardRef(function NavaidNdbDme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12H2V4A2.0021,2.0021,0,0,1,4,2h8V4H4Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V20H4v8h8Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20V28h8V20h2v8A2.0021,2.0021,0,0,1,28,30Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12H28V4H20V2h8a2.0021,2.0021,0,0,1,2,2Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidNdbDme.propTypes = iconPropTypes;
}
const NavaidPrivate = /*#__PURE__*/React.forwardRef(function NavaidPrivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidPrivate.propTypes = iconPropTypes;
}
const NavaidSeaplane = /*#__PURE__*/React.forwardRef(function NavaidSeaplane({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidSeaplane.propTypes = iconPropTypes;
}
const NavaidTacan = /*#__PURE__*/React.forwardRef(function NavaidTacan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidTacan.propTypes = iconPropTypes;
}
const NavaidVhfor = /*#__PURE__*/React.forwardRef(function NavaidVhfor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidVhfor.propTypes = iconPropTypes;
}
const NavaidVor = /*#__PURE__*/React.forwardRef(function NavaidVor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidVor.propTypes = iconPropTypes;
}
const NavaidVordme = /*#__PURE__*/React.forwardRef(function NavaidVordme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidVordme.propTypes = iconPropTypes;
}
const NavaidVortac = /*#__PURE__*/React.forwardRef(function NavaidVortac({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NavaidVortac.propTypes = iconPropTypes;
}
const Need = /*#__PURE__*/React.forwardRef(function Need({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211,16.8789A2.98,2.98,0,0,0,27.01,16H27a2.9774,2.9774,0,0,0-2.1211.8789L19.9778,21.78A2.9943,2.9943,0,0,0,17,19H10a5.0059,5.0059,0,0,0-5,5v.667L2,28.6631l1.6,1.2L7,25.333V24a3.0033,3.0033,0,0,1,3-3h7a1,1,0,0,1,0,2H13v2h4.9287a3.9717,3.9717,0,0,0,2.8286-1.1719L26.293,18.293A.9929.9929,0,0,1,27,18h.0034a1,1,0,0,1,.7036,1.707l-7.414,7.4141A2.9791,2.9791,0,0,1,18.1714,28H11v2h7.1714a4.9665,4.9665,0,0,0,3.5356-1.4648l7.4141-7.4141a2.9989,2.9989,0,0,0,0-4.2422Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Need.propTypes = iconPropTypes;
}
const Network_1 = /*#__PURE__*/React.forwardRef(function Network_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,5,20Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,5,14Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,25Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,25Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,27,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,27,14Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,3Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_1.propTypes = iconPropTypes;
}
const Network_2 = /*#__PURE__*/React.forwardRef(function Network_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_2.propTypes = iconPropTypes;
}
const Network_3 = /*#__PURE__*/React.forwardRef(function Network_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H8A6,6,0,0,1,8,15h2v2H8a4,4,0,0,0,0,8H20Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_3.propTypes = iconPropTypes;
}
const Network_3Reference = /*#__PURE__*/React.forwardRef(function Network_3Reference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_3Reference.propTypes = iconPropTypes;
}
const Network_4 = /*#__PURE__*/React.forwardRef(function Network_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_4.propTypes = iconPropTypes;
}
const Network_4Reference = /*#__PURE__*/React.forwardRef(function Network_4Reference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Network_4Reference.propTypes = iconPropTypes;
}
const NetworkAdminControl = /*#__PURE__*/React.forwardRef(function NetworkAdminControl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4a4.0045,4.0045,0,0,0-4,4,3.951,3.951,0,0,0,.5669,2.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkAdminControl.propTypes = iconPropTypes;
}
const NetworkEnterprise = /*#__PURE__*/React.forwardRef(function NetworkEnterprise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H26V20H24z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V26H20z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H26V26H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkEnterprise.propTypes = iconPropTypes;
}
const NetworkOverlay = /*#__PURE__*/React.forwardRef(function NetworkOverlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkOverlay.propTypes = iconPropTypes;
}
const NetworkPublic = /*#__PURE__*/React.forwardRef(function NetworkPublic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5 C27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21 c0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9 C28.3,25,26.9,26.7,25.1,27.5z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5 c-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkPublic.propTypes = iconPropTypes;
}
const NetworkInterface = /*#__PURE__*/React.forwardRef(function NetworkInterface({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m28,18h-2V6h-13v-2h13c1.1028,0,2,.8972,2,2v12Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m18,28H6c-1.1028,0-2-.8972-2-2v-13h2v13h12v2Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m26,21l-1.793,1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852,0-1.6543-1.3457-3-3-3-.4617,0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4c.7395,0,1.4241-.2153,2.019-.5669l5.2815,5.2817c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3,.4617,0,.894-.1133,1.2852-.3008l5.5078,5.5078-1.793,1.793,5,5,5-5-5-5ZM4,6c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Zm11,10c0-.5513.4485-1,1-1s1,.4487,1,1-.4485,1-1,1-1-.4487-1-1Zm8.8286,10l2.1714-2.1714,2.1714,2.1714-2.1714,2.1714-2.1714-2.1714Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkInterface.propTypes = iconPropTypes;
}
const NetworkTimeProtocol = /*#__PURE__*/React.forwardRef(function NetworkTimeProtocol({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,27c-.3-.9-1-1.5-1.8-1.8v-3.2c5-.5,9-4.8,9-9.9S21.5,2.1,16,2.1,6,6.5,6,12s3.9,9.5,9,10v3.2c-.9.3-1.5,1-1.8,1.8H4v2h9.2c.4,1.2,1.5,2,2.8,2s2.4-.8,2.8-2h9.2v-2h-9.2ZM8,12c0-4.4,3.6-8,8-8s8,3.6,8,8-3.6,8-8,8-8-3.6-8-8ZM16,29c-.6,0-1-.5-1-1s.4-1,1-1,1,.5,1,1-.5,1-1,1ZM19.3,16.7l-4.3-4.3v-6.4h2v5.6l3.7,3.7s-1.4,1.4-1.4,1.4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NetworkTimeProtocol.propTypes = iconPropTypes;
}
const NewTab = /*#__PURE__*/React.forwardRef(function NewTab({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
      d: "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
    })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
      d: "M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NewTab.propTypes = iconPropTypes;
}
const NextFilled = /*#__PURE__*/React.forwardRef(function NextFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NextFilled.propTypes = iconPropTypes;
}
const NextOutline = /*#__PURE__*/React.forwardRef(function NextOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NextOutline.propTypes = iconPropTypes;
}
const NoImage = /*#__PURE__*/React.forwardRef(function NoImage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NoImage.propTypes = iconPropTypes;
}
const NoTicket = /*#__PURE__*/React.forwardRef(function NoTicket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6h-.5859L30,3.4141,28.5859,2,2,28.5859,3.4141,30l4-4H28a2.0027,2.0027,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4,1,1,0,0,0,1-1V8A2.0023,2.0023,0,0,0,28,6Zm0,6.1265a4,4,0,0,0,0,7.7465V24H21V21H19v3H9.4141L19,14.4141V19h2V12.4141L25.4141,8H28Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12.1265V8H19V6H4A2.0023,2.0023,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5H4V19.873a4,4,0,0,0,0-7.7465Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NoTicket.propTypes = iconPropTypes;
}
const Nominal = /*#__PURE__*/React.forwardRef(function Nominal({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
      d: "M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,28Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,18Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,8,28ZM8,18a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,8,18Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,14ZM16,4a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Nominal.propTypes = iconPropTypes;
}
const WatsonHealthNominate = /*#__PURE__*/React.forwardRef(function WatsonHealthNominate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H19a3,3,0,0,0-3,3v2h2V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V26A3,3,0,0,0,25,23Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18a4,4,0,1,0,4-4A4,4,0,0,0,18,18Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,24,18Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthNominate.propTypes = iconPropTypes;
}
const NonCertified = /*#__PURE__*/React.forwardRef(function NonCertified({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H14V14H6z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H10V18H6z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NonCertified.propTypes = iconPropTypes;
}
const NoodleBowl = /*#__PURE__*/React.forwardRef(function NoodleBowl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NoodleBowl.propTypes = iconPropTypes;
}
const NotAvailable = /*#__PURE__*/React.forwardRef(function NotAvailable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H14V17H4z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H28V17H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotAvailable.propTypes = iconPropTypes;
}
const NotSent = /*#__PURE__*/React.forwardRef(function NotSent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8ZM5.8,15,11.54,13l3.05,3-1.83,1.83ZM17,26.2l-2.79-7L16,17.41l3,3.05Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69,11.45l7.64-2.78-2.78,7.64,1.56,1.56L25.94,7.34a1,1,0,0,0-1.28-1.28L14.13,9.89Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotSent.propTypes = iconPropTypes;
}
const NotSentFilled = /*#__PURE__*/React.forwardRef(function NotSentFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l8.59,3.43L14.59,16,16,17.41l-3.37,3.37,3.44,8.59A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,16.83l3.45-9.49a1,1,0,0,0-1.28-1.28L15.17,9.51Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotSentFilled.propTypes = iconPropTypes;
}
const Notebook = /*#__PURE__*/React.forwardRef(function Notebook({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H26V17H19z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H26V22H19z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Notebook.propTypes = iconPropTypes;
}
const NotebookReference = /*#__PURE__*/React.forwardRef(function NotebookReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H26V17H19z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H26V22H19z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotebookReference.propTypes = iconPropTypes;
}
const Notification = /*#__PURE__*/React.forwardRef(function Notification({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
      d: "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12 c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5 C14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4 C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Notification.propTypes = iconPropTypes;
}
const NotificationFilled = /*#__PURE__*/React.forwardRef(function NotificationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationFilled.propTypes = iconPropTypes;
}
const NotificationNew = /*#__PURE__*/React.forwardRef(function NotificationNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "4"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationNew.propTypes = iconPropTypes;
}
const NotificationOff = /*#__PURE__*/React.forwardRef(function NotificationOff({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
      d: "M2.5,11.5v-0.8l1.3-1.4C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4c0.9,0,1.8,0.3,2.5,0.9l0.7-0.7C10.5,2,9.5,1.6,8.5,1.5v-1h-1 v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4v1H2.5z"
    })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
      d: "M13,8.8V6.5c0-0.8-0.2-1.6-0.5-2.2L15,1.7L14.3,1L1,14.3L1.7,15l2.5-2.5h1.3C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14 c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5c0-0.1-0.1-0.3-0.1-0.4L13,8.8z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5H5.2L11.7,5C11.9,5.5,12,6,12,6.5V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V13a9.9217,9.9217,0,0,0-1.0833-4.5024L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H11.4141L23.4119,10.0024A7.949,7.949,0,0,1,24,13v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M7.707,17.707A1,1,0,0,0,8,17V13a8.0092,8.0092,0,0,1,8-8,7.9253,7.9253,0,0,1,4.9857,1.7681l1.4264-1.4263A9.934,9.934,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859l-3,3L4.4141,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationOff.propTypes = iconPropTypes;
}
const NotificationOffFilled = /*#__PURE__*/React.forwardRef(function NotificationOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V13a9.8828,9.8828,0,0,0-1.0869-4.499L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a.9993.9993,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.61,4.7383A9.9256,9.9256,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a.9738.9738,0,0,0,.0585.29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationOffFilled.propTypes = iconPropTypes;
}
const NotificationCounter = /*#__PURE__*/React.forwardRef(function NotificationCounter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,12v15H5V5h15v-2H5c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h22c1.1046,0,2-.8954,2-2v-15h-2Z"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.5",
    cy: "5.5",
    r: "3.5",
    strokeWidth: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationCounter.propTypes = iconPropTypes;
}
const NotificationsPaused = /*#__PURE__*/React.forwardRef(function NotificationsPaused({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5l-3.625,4h3.625v2h-6v-2l3.75-4h-3.75v-2h6v2ZM28.707,19.293c.1875.1875.293.4419.293.707v3c0,.5522-.4473,1-1,1h-7v1c0,2.7568-2.2432,5-5,5s-5-2.2432-5-5v-1h-7c-.5527,0-1-.4478-1-1v-3c0-.2651.1055-.5195.293-.707l2.707-2.707v-3.5859c0-5.1763,3.9541-9.4458,9-9.9492V1h2v2.0508c1.0583.1055,2.0641.3853,3,.7959v2.1533c-1.1783-.6841-2.5422-1-4-1-4.4111,0-8,3.5889-8,8v4c0,.2651-.1055.5195-.293.707l-2.707,2.707v1.586h22v-1.586l-2.707-2.707c-.1875-.1875-.293-.4419-.293-.707v-3h2v2.5859l2.707,2.707h0ZM19,24h-6v1c0,1.6543,1.3457,3,3,3s3-1.3457,3-3v-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationsPaused.propTypes = iconPropTypes;
}
const NullSign = /*#__PURE__*/React.forwardRef(function NullSign({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4142l-1.4142-1.4142-3.4317,3.4317c-2.4572-2.1313-5.6536-3.4317-9.1541-3.4317-7.7197,0-14,6.2803-14,14,0,3.5005,1.3004,6.6969,3.4317,9.1541l-3.4317,3.4317,1.4142,1.4142,3.4317-3.4317c2.4572,2.1313,5.6536,3.4317,9.1541,3.4317,7.7197,0,14-6.2803,14-14,0-3.5005-1.3004-6.6969-3.4317-9.1541,0,0,3.4317-3.4317,3.4317-3.4317ZM4,16c0-6.6167,5.3833-12,12-12,2.9492,0,5.649,1.0739,7.7406,2.8452L6.8452,23.7406c-1.7713-2.0916-2.8452-4.7914-2.8452-7.7406ZM28,16c0,6.6172-5.3828,12-12,12-2.9491,0-5.6489-1.074-7.7405-2.8453L25.1547,8.2595c1.7713,2.0916,2.8453,4.7914,2.8453,7.7405Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NullSign.propTypes = iconPropTypes;
}
const Number_0 = /*#__PURE__*/React.forwardRef(function Number_0({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_0.propTypes = iconPropTypes;
}
const Number_1 = /*#__PURE__*/React.forwardRef(function Number_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_1.propTypes = iconPropTypes;
}
const Number_2 = /*#__PURE__*/React.forwardRef(function Number_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_2.propTypes = iconPropTypes;
}
const Number_3 = /*#__PURE__*/React.forwardRef(function Number_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_3.propTypes = iconPropTypes;
}
const Number_4 = /*#__PURE__*/React.forwardRef(function Number_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_4.propTypes = iconPropTypes;
}
const Number_5 = /*#__PURE__*/React.forwardRef(function Number_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_5.propTypes = iconPropTypes;
}
const Number_6 = /*#__PURE__*/React.forwardRef(function Number_6({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_6.propTypes = iconPropTypes;
}
const Number_7 = /*#__PURE__*/React.forwardRef(function Number_7({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_7.propTypes = iconPropTypes;
}
const Number_8 = /*#__PURE__*/React.forwardRef(function Number_8({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_8.propTypes = iconPropTypes;
}
const Number_9 = /*#__PURE__*/React.forwardRef(function Number_9({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_9.propTypes = iconPropTypes;
}
const NumberSmall_0 = /*#__PURE__*/React.forwardRef(function NumberSmall_0({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_0.propTypes = iconPropTypes;
}
const NumberSmall_1 = /*#__PURE__*/React.forwardRef(function NumberSmall_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_1.propTypes = iconPropTypes;
}
const NumberSmall_2 = /*#__PURE__*/React.forwardRef(function NumberSmall_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_2.propTypes = iconPropTypes;
}
const NumberSmall_3 = /*#__PURE__*/React.forwardRef(function NumberSmall_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_3.propTypes = iconPropTypes;
}
const NumberSmall_4 = /*#__PURE__*/React.forwardRef(function NumberSmall_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_4.propTypes = iconPropTypes;
}
const NumberSmall_5 = /*#__PURE__*/React.forwardRef(function NumberSmall_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_5.propTypes = iconPropTypes;
}
const NumberSmall_6 = /*#__PURE__*/React.forwardRef(function NumberSmall_6({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_6.propTypes = iconPropTypes;
}
const NumberSmall_7 = /*#__PURE__*/React.forwardRef(function NumberSmall_7({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_7.propTypes = iconPropTypes;
}
const NumberSmall_8 = /*#__PURE__*/React.forwardRef(function NumberSmall_8({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_8.propTypes = iconPropTypes;
}
const NumberSmall_9 = /*#__PURE__*/React.forwardRef(function NumberSmall_9({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_9.propTypes = iconPropTypes;
}
const Object$1 = /*#__PURE__*/React.forwardRef(function Object({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M6,3h4v2h-4v8c0,1.2002-.5425,2.2661-1.3823,3,.8398.7339,1.3823,1.7998,1.3823,3v8h4v2h-4c-1.103,0-2-.8975-2-2v-8c0-1.1025-.897-2-2-2v-2c1.103,0,2-.8975,2-2V5c0-1.1025.897-2,2-2ZM28,13V5c0-1.1025-.897-2-2-2h-4v2h4v8c0,1.2002.5425,2.2661,1.3823,3-.8398.7339-1.3823,1.7998-1.3823,3v8h-4v2h4c1.103,0,2-.8975,2-2v-8c0-1.1025.897-2,2-2v-2c-1.103,0-2-.8975-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Object$1.propTypes = iconPropTypes;
}
const ObjectStorage = /*#__PURE__*/React.forwardRef(function ObjectStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8H22v6H16v8h8V16h6ZM22,20H18V16h4Zm6-6H24V10h4Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H10V2h8ZM12,8h4V4H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObjectStorage.propTypes = iconPropTypes;
}
const ObjectStorageAlt = /*#__PURE__*/React.forwardRef(function ObjectStorageAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObjectStorageAlt.propTypes = iconPropTypes;
}
const ObservedHail = /*#__PURE__*/React.forwardRef(function ObservedHail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "23.5",
    r: "1.5"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "19.5",
    r: "1.5"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "19.5",
    r: "1.5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M11.964 14.5H17.036V16.499H11.964z",
    transform: "rotate(-45 14.5 15.5)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 14.5H23.035999999999998V16.499H17.964z",
    transform: "rotate(-45 20.5 15.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObservedHail.propTypes = iconPropTypes;
}
const ObservedLightning = /*#__PURE__*/React.forwardRef(function ObservedLightning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObservedLightning.propTypes = iconPropTypes;
}
const Omega = /*#__PURE__*/React.forwardRef(function Omega({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Omega.propTypes = iconPropTypes;
}
const Opacity = /*#__PURE__*/React.forwardRef(function Opacity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14V14H10z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H18V10H14z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H10V18H6z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H18V18H14z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H26V18H22z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H18V26H14z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H26V26H22z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H22V14H18z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V22H10z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V22H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Opacity.propTypes = iconPropTypes;
}
const OpenPanelBottom = /*#__PURE__*/React.forwardRef(function OpenPanelBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelBottom.propTypes = iconPropTypes;
}
const OpenPanelFilledBottom = /*#__PURE__*/React.forwardRef(function OpenPanelFilledBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledBottom.propTypes = iconPropTypes;
}
const OpenPanelFilledLeft = /*#__PURE__*/React.forwardRef(function OpenPanelFilledLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledLeft.propTypes = iconPropTypes;
}
const OpenPanelFilledRight = /*#__PURE__*/React.forwardRef(function OpenPanelFilledRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledRight.propTypes = iconPropTypes;
}
const OpenPanelFilledTop = /*#__PURE__*/React.forwardRef(function OpenPanelFilledTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledTop.propTypes = iconPropTypes;
}
const OpenPanelLeft = /*#__PURE__*/React.forwardRef(function OpenPanelLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelLeft.propTypes = iconPropTypes;
}
const OpenPanelRight = /*#__PURE__*/React.forwardRef(function OpenPanelRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelRight.propTypes = iconPropTypes;
}
const OpenPanelTop = /*#__PURE__*/React.forwardRef(function OpenPanelTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelTop.propTypes = iconPropTypes;
}
const QOperation = /*#__PURE__*/React.forwardRef(function QOperation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26L21 26 26 16 21 6 23 6 28 16 23 26z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V26H4z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9H12a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,16,9Zm0,12H12V11h4Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V17H13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperation.propTypes = iconPropTypes;
}
const QOperationGauge = /*#__PURE__*/React.forwardRef(function QOperationGauge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17.62,22.08,14l-1.73-1-2.18,3.76A12,12,0,0,0,2,28H4a10,10,0,0,1,13.16-9.48L14,24a2,2,0,1,0,2,2,2,2,0,0,0-.27-1L19,19.35A10,10,0,0,1,24,28h2A12,12,0,0,0,20,17.62Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperationGauge.propTypes = iconPropTypes;
}
const QOperationIf = /*#__PURE__*/React.forwardRef(function QOperationIf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H14V23H12z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H14V11H12z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11V9H20a2,2,0,0,0-2,2v2H16v2h2v8h2V15h3V13H20V11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperationIf.propTypes = iconPropTypes;
}
const OperationsField = /*#__PURE__*/React.forwardRef(function OperationsField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H26V8H16z",
    transform: "rotate(-90 21 7)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z",
    transform: "rotate(-90 25 7)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H34V8H24z",
    transform: "rotate(-90 29 7)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OperationsField.propTypes = iconPropTypes;
}
const OperationsRecord = /*#__PURE__*/React.forwardRef(function OperationsRecord({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28H30V30H20z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4,3.9123,3.9123,0,0,1,4,4h2a6,6,0,1,0-6,6Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OperationsRecord.propTypes = iconPropTypes;
}
const OrderDetails = /*#__PURE__*/React.forwardRef(function OrderDetails({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13a3,3,0,0,0-3,3v2h2V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V24A3,3,0,0,0,19,21Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OrderDetails.propTypes = iconPropTypes;
}
const Ordinal = /*#__PURE__*/React.forwardRef(function Ordinal({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
      d: "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ordinal.propTypes = iconPropTypes;
}
const Outage = /*#__PURE__*/React.forwardRef(function Outage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H21V26H12z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7832,18.9746l1.4177-1.418A6.9206,6.9206,0,0,1,8,12,7.99,7.99,0,0,1,21.5273,6.2305l1.4136-1.4136A9.9884,9.9884,0,0,0,6,12,8.9411,8.9411,0,0,0,8.7832,18.9746Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30,23.6606,9.7534A7.7069,7.7069,0,0,1,24,12a7.2032,7.2032,0,0,1-2.8223,6.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12a9.8739,9.8739,0,0,0-.7764-3.81Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Outage.propTypes = iconPropTypes;
}
const OutlookSevere = /*#__PURE__*/React.forwardRef(function OutlookSevere({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OutlookSevere.propTypes = iconPropTypes;
}
const OverflowMenuHorizontal = /*#__PURE__*/React.forwardRef(function OverflowMenuHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuHorizontal.propTypes = iconPropTypes;
}
const OverflowMenuVertical = /*#__PURE__*/React.forwardRef(function OverflowMenuVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuVertical.propTypes = iconPropTypes;
}
const Overlay = /*#__PURE__*/React.forwardRef(function Overlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Overlay.propTypes = iconPropTypes;
}
const Package = /*#__PURE__*/React.forwardRef(function Package({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H19V22H13z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Package.propTypes = iconPropTypes;
}
const PackageTextAnalysis = /*#__PURE__*/React.forwardRef(function PackageTextAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22H19V24H13z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m2,18v2h2v8c0,1.1025.8972,2,2,2h20c1.1028,0,2-.8975,2-2v-8h2v-2H2Zm24,10H6v-8h20v8Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m29,16h-5c-1.1025,0-2-.8975-2-2v-6c0-1.103.8975-2,2-2h5v2h-5v6h5v2Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m18,6h-4v-4h-2v14h6c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2Zm-4,8v-6h4v6h-4Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m8,6H3v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6V8c0-1.103-.8975-2-2-2Zm0,8h-4v-2h4v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PackageTextAnalysis.propTypes = iconPropTypes;
}
const PackageNode = /*#__PURE__*/React.forwardRef(function PackageNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,28H4c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h10c1.1028,0,2,.8972,2,2v4h12c1.1028,0,2,.8972,2,2v14c0,1.1028-.8972,2-2,2ZM4,12v14h24v-14H4Zm0-2h10v-4H4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PackageNode.propTypes = iconPropTypes;
}
const PageFirst = /*#__PURE__*/React.forwardRef(function PageFirst({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H10V28H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageFirst.propTypes = iconPropTypes;
}
const PageLast = /*#__PURE__*/React.forwardRef(function PageLast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H24V28H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageLast.propTypes = iconPropTypes;
}
const PageBreak = /*#__PURE__*/React.forwardRef(function PageBreak({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V20H26z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22v6H8V22H6v6a2.0058,2.0058,0,0,0,2,2H24a2.0058,2.0058,0,0,0,2-2V22Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16ZM18,4.4,23.6,10H18Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V20H10z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageBreak.propTypes = iconPropTypes;
}
const PageNumber = /*#__PURE__*/React.forwardRef(function PageNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageNumber.propTypes = iconPropTypes;
}
const WatsonHealthPageScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthPageScroll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24V6H16V4h8a1.89,1.89,0,0,1,2,2Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPageScroll.propTypes = iconPropTypes;
}
const PaintBrush = /*#__PURE__*/React.forwardRef(function PaintBrush({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrush.propTypes = iconPropTypes;
}
const PaintBrushAlt = /*#__PURE__*/React.forwardRef(function PaintBrushAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrushAlt.propTypes = iconPropTypes;
}
const PalmTree = /*#__PURE__*/React.forwardRef(function PalmTree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PalmTree.propTypes = iconPropTypes;
}
const PanHorizontal = /*#__PURE__*/React.forwardRef(function PanHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanHorizontal.propTypes = iconPropTypes;
}
const PanVertical = /*#__PURE__*/React.forwardRef(function PanVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanVertical.propTypes = iconPropTypes;
}
const PanelExpansion = /*#__PURE__*/React.forwardRef(function PanelExpansion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6H6A2,2,0,0,0,4,8v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,12,6ZM6,14V8h6v6Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,26,6ZM20,24V8h6V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanelExpansion.propTypes = iconPropTypes;
}
const Paragraph = /*#__PURE__*/React.forwardRef(function Paragraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paragraph.propTypes = iconPropTypes;
}
const Parameter = /*#__PURE__*/React.forwardRef(function Parameter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Parameter.propTypes = iconPropTypes;
}
const ParentChild = /*#__PURE__*/React.forwardRef(function ParentChild({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ParentChild.propTypes = iconPropTypes;
}

export { Move, Movement, Mp3, Mp4, Mpeg, Mpg2, MultiuserDevice, Music, MusicAdd, MusicRemove, Mysql, NameSpace, NavaidCivil, NavaidDme, NavaidHelipad, NavaidMilitary, NavaidMilitaryCivil, NavaidNdb, NavaidNdbDme, NavaidPrivate, NavaidSeaplane, NavaidTacan, NavaidVhfor, NavaidVor, NavaidVordme, NavaidVortac, Need, NetworkAdminControl, NetworkEnterprise, NetworkInterface, NetworkOverlay, NetworkPublic, NetworkTimeProtocol, Network_1, Network_2, Network_3, Network_3Reference, Network_4, Network_4Reference, NewTab, NextFilled, NextOutline, NoImage, NoTicket, Nominal, NonCertified, NoodleBowl, NotAvailable, NotSent, NotSentFilled, Notebook, NotebookReference, Notification, NotificationCounter, NotificationFilled, NotificationNew, NotificationOff, NotificationOffFilled, NotificationsPaused, NullSign, NumberSmall_0, NumberSmall_1, NumberSmall_2, NumberSmall_3, NumberSmall_4, NumberSmall_5, NumberSmall_6, NumberSmall_7, NumberSmall_8, NumberSmall_9, Number_0, Number_1, Number_2, Number_3, Number_4, Number_5, Number_6, Number_7, Number_8, Number_9, Object$1 as Object, ObjectStorage, ObjectStorageAlt, ObservedHail, ObservedLightning, Omega, Opacity, OpenPanelBottom, OpenPanelFilledBottom, OpenPanelFilledLeft, OpenPanelFilledRight, OpenPanelFilledTop, OpenPanelLeft, OpenPanelRight, OpenPanelTop, OperationsField, OperationsRecord, OrderDetails, Ordinal, Outage, OutlookSevere, OverflowMenuHorizontal, OverflowMenuVertical, Overlay, Package, PackageNode, PackageTextAnalysis, PageBreak, PageFirst, PageLast, PageNumber, PaintBrush, PaintBrushAlt, PalmTree, PanHorizontal, PanVertical, PanelExpansion, Paragraph, Parameter, ParentChild, QOperation, QOperationGauge, QOperationIf, WatsonHealthNominate, WatsonHealthPageScroll };
